import { useEffect, useState } from "react";
import api from "./api";

let cache = null;
let pending = null;

export function useEmergencies() {
  const [data, setData] = useState(cache);
  useEffect(() => {
    if (cache) return;
    pending = pending || api.get("/public/emergencies").then(({ data: d }) => (cache = d));
    pending.then(setData).catch(() => { pending = null; });
  }, []);
  return data;
}

export function relevantProtocols(data, itemIds) {
  if (!data) return [];
  const hits = {};
  itemIds.forEach((iid) => (data.item_map[iid] || []).forEach((pid) => { (hits[pid] = hits[pid] || []).push(iid); }));
  const byId = Object.fromEntries(data.protocols.map((p) => [p.id, p]));
  const list = Object.keys(hits).filter((pid) => pid !== "cardiac_arrest").map((pid) => byId[pid]);
  return [...list, byId.cardiac_arrest];
}

export const openEmergency = (id) => window.dispatchEvent(new CustomEvent("open-emergency", { detail: id || null }));
